import * as FetchJSONHelper from '../../helpers/FetchJSONHelper'
import JSONFilesEnum from '../../enums/JSONFilesEnum';
import { WorkerDetailsProps, WorkerDetailsState } from './WorkerDetails';

export class WorkerDetailsController {
    public setState = (() => { }) as (partialState: any) => void
    public getState = (): WorkerDetailsState => { return {} as any }

    private props: WorkerDetailsProps = {}

    /* Base controller configuration */

    config = (setState: (partialState: any, overwrite?: boolean) => void, getState: () => WorkerDetailsState, getDefaultState: () => WorkerDetailsState, props: WorkerDetailsProps) => {
        this.setState = setState
        this.getState = getState
        this.props = props
    }

    /* Initializers */

    initialize = (params: any) => {
        // this.initializeAll();
        // this.setState({ overwrite: true })
        // setTimeout(() => {
        this.initializeWorker(params);
        this.initializeWorkerJTC(params);
        this.initializeWorkerPathWay(params);
        this.initializeWorkerTrainingProgramCareer(params);
        // }, 2000);

    }

    // initializeAll = () => {
    //     this.setState({
    //         isJTCVisible: false,
    //         isButtonClick: true,
    //         isShoeHideTrainigSection: '',
    //         isTrainingAndPathWayVisible: false,
    //         workerResponse: [],
    //         workerBgUrlResponse: [],
    //         workerJTCResponse: [],
    //         workerPathWayResponse: [],
    //         workersTrainingProgramResponse: [],
    //         activeVimeoLink: '',
    //         isPathWayLabel: '0'
    //     })
    // }

    initializeWorker = (params: any) => {
        this.getWorkersBackend((usersJson: any) => {
            this.setState({ workerResponse: usersJson.workers.filter((w: { id: number; }) => w.id === parseInt(params.id)) })
            this.setState({ workerBgUrlResponse: usersJson.workers.map((img: { workerBgUrl: any; }) => img.workerBgUrl) })
        }, (e: Response) => {
            console.log("usersJson errors ==>", e)
        })
    }

    initializeWorkerJTC = (params: any) => {
        this.getWorkersJTCBackend((usersJson: any) => {
            this.setState({ workerJTCResponse: usersJson.workerJTC.filter((w: { id: number; }) => w.id === parseInt(params.id)) })
        }, (e: Response) => {
            console.log("usersJson errors ==>", e)
        })
    }

    initializeWorkerPathWay = (params: any) => {
        this.getWorkersPathWayBackend((usersJson: any) => {
            this.setState({ workerPathWayResponse: usersJson.workerPathWay.filter((w: { id: number; }) => w.id === parseInt(params.id)) })
        }, (e: Response) => {
            console.log("usersJson errors ==>", e)
        })
    }

    initializeWorkerTrainingProgramCareer = (params: any) => {
        this.getWorkersTrainingProgramCareerBackend((usersJson: any) => {
            this.setState({ workersTrainingProgramResponse: usersJson.workersProgram.filter((w: { id: number; }) => w.id === parseInt(params.id)) })
        }, (e: Response) => {
            console.log("usersJson errors ==>", e)
        })
    }

    /* others functions */

    manageJTCSection = (vimeoLink: string) => {
        this.setState({
            isJTCVisible: !this.getState().isJTCVisible,
            activeVimeoLink: vimeoLink
        })
    }

    manageTrainingAndPathWaySection = (isTrainingOrPathWaySection: any, isShoeHideTrainigSection: string, WorkerPathwayContainID?: number) => {
        this.setState({
            isPathWayLabel: isTrainingOrPathWaySection,
            isButtonClick: false,
            WorkerPathwayContainID
        })
        this.toShowHideClassForTrainig(isShoeHideTrainigSection)
    }

    toShowHideClassForTrainig = (shoeHideTrainigSection: string) => {
        this.setState({
            isShoeHideTrainigSection: shoeHideTrainigSection
        })
    }

    openInNewTab = (url: string) => {
        window.open(url, '_blank');
    };

    /* Backend JSON Files calls */

    private getWorkersBackend = (success?: (users: any) => void, error?: (e: Response) => void) => {
        FetchJSONHelper.callJSONFiles(JSONFilesEnum.WORKERS_JSON, 'GET', success, error);
    }

    private getWorkersJTCBackend = (success?: (users: any) => void, error?: (e: Response) => void) => {
        FetchJSONHelper.callJSONFiles(JSONFilesEnum.WORKERS_JSON_JTC, 'GET', success, error);
    }

    private getWorkersPathWayBackend = (success?: (users: any) => void, error?: (e: Response) => void) => {
        FetchJSONHelper.callJSONFiles(JSONFilesEnum.WORKERS_JSON_PATHWAY, 'GET', success, error);
    }

    private getWorkersTrainingProgramCareerBackend = (success?: (users: any) => void, error?: (e: Response) => void) => {
        FetchJSONHelper.callJSONFiles(JSONFilesEnum.TRAINING_PROGRAM_CAREER, 'GET', success, error);
    }
}